import React from 'react'
import ShowAll from '../conponents/operate/show-all'


const AllServicesPage = () => {
  return (
    <ShowAll/>
  )
}

export default AllServicesPage